export default function ButtonBorder({ type = "button", onClick, className, children }) {
    return (
        <button className={"btnPrimaryOutline btn btn-outline-primary" + (className || "")} type={type} onClick={onClick}>
            {children}
        </button>
    );
}
